// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AgeCheckQueryVariables = Types.Exact<{
  clientProfileId: Types.Scalars['ID']['input'];
  shouldCheckAge: Types.Scalars['Boolean']['input'];
}>;


export type AgeCheckQuery = { __typename?: 'Query', clientProfiles?: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: { __typename?: 'ClientProfile', id: string, dateOfBirth?: Time | null } | null } | null> | null } };

export const Operations = {
  Query: {
    AgeCheck: 'AgeCheck' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const AgeCheckDocument = gql`
    query AgeCheck($clientProfileId: ID!, $shouldCheckAge: Boolean!) {
  clientProfiles(where: {id: $clientProfileId}) @include(if: $shouldCheckAge) {
    edges {
      node {
        id
        dateOfBirth
      }
    }
  }
}
    `;

/**
 * __useAgeCheckQuery__
 *
 * To run a query within a React component, call `useAgeCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgeCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgeCheckQuery({
 *   variables: {
 *      clientProfileId: // value for 'clientProfileId'
 *      shouldCheckAge: // value for 'shouldCheckAge'
 *   },
 * });
 */
export function useAgeCheckQuery(baseOptions: Apollo.QueryHookOptions<AgeCheckQuery, AgeCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgeCheckQuery, AgeCheckQueryVariables>(AgeCheckDocument, withFetchPolicyContext(options));
      }
export function useAgeCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgeCheckQuery, AgeCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgeCheckQuery, AgeCheckQueryVariables>(AgeCheckDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useAgeCheckSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgeCheckQuery, AgeCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgeCheckQuery, AgeCheckQueryVariables>(AgeCheckDocument, withFetchPolicyContext(options));
        }
export type AgeCheckQueryHookResult = ReturnType<typeof useAgeCheckQuery>;
export type AgeCheckLazyQueryHookResult = ReturnType<typeof useAgeCheckLazyQuery>;
export type AgeCheckSuspenseQueryHookResult = ReturnType<typeof useAgeCheckSuspenseQuery>;
export type AgeCheckQueryResult = Apollo.QueryResult<AgeCheckQuery, AgeCheckQueryVariables>;